import React from 'react';
import { Modal, LockboxModalHeader } from '../ui';
import Button from '../ui/Button';
import {
  GUEST_REGISTRATION_BODY,
  GUEST_REGISTRATION_TITLE,
} from '../../utils/accessControl';

export default function GuestRegistrationPrompt({
  open,
  onClose,
  onCreateAccount,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      accent="warning"
      size="md"
      panelClassName="rounded-[2rem] max-w-md"
      bodyClassName="p-6 md:p-8"
      header={(
        <LockboxModalHeader
          emoji="🔐"
          iconClassName="bg-amber-500/10 border-amber-500/30"
          title={GUEST_REGISTRATION_TITLE}
          subtitle="Browse now · create an account to play"
          onClose={onClose}
        />
      )}
    >
      <p className="text-sm text-gray-300 font-medium leading-relaxed mb-6">
        {GUEST_REGISTRATION_BODY}
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button type="button" variant="primary" className="flex-1" onClick={onCreateAccount}>
          Create Free Account
        </Button>
        <Button type="button" variant="secondary" className="flex-1" onClick={onClose}>
          Keep Browsing
        </Button>
      </div>
    </Modal>
  );
}
